import { render } from "./AppGlobalModal.vue?vue&type=template&id=1fc52e2c&scoped=true&ts=true"
import script from "./AppGlobalModal.vue?vue&type=script&lang=ts"
export * from "./AppGlobalModal.vue?vue&type=script&lang=ts"

import "./AppGlobalModal.vue?vue&type=style&index=0&id=1fc52e2c&scoped=true&lang=css"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc52e2c"]])

export default __exports__